var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{ref:"searchTags",staticClass:"large",staticStyle:{"height":"39px","overflow":"visible!important"},attrs:{"options":_vm.foundTags,"placeholder":_vm.getSearchTagVal()},on:{"search-change":_vm.searchTags,"select":_vm.addTags},model:{value:(_vm.selectedTag),callback:function ($$v) {_vm.selectedTag=$$v},expression:"selectedTag"}})
}
var staticRenderFns = []

export { render, staticRenderFns }